export default {
  rooms: state => {
    return state.rooms;
  },
  roomById: state => id => {
    if (state.rooms && state.rooms.length > 0) {
      const filtered = state.rooms.filter(item => parseInt(item.id) === parseInt(id));

      return filtered && filtered[0] ? filtered[0] : null;
    }

    return null;
  },
  floors: state => {
    return state.floors;
  },
  floorById: state => id => {
    if (state.floors && state.floors.length > 0) {
      const filtered = state.floors.filter(item => parseInt(item.id) === parseInt(id));

      return filtered && filtered[0] ? filtered[0] : null;
    }

    return null;
  }
};